import React from 'react';
import { withProps, compose, pure, withHandlers, withState, mapProps } from 'recompose';
import { omit, path, pick } from 'ramda';
import { Game as CommonGame } from 'js/components/common/Game';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import style from './index.scss';
import ResizeObserver from 'resize-observer-polyfill';
import Jackpot from '../../../main/Games/Jackpot';
import { CATEGORY_TYPE } from 'js/components/main/Games/constants';
import { useJackpotsConfiguration } from '@theme/js/components/system/App/hooks/useJackpotsConfiguration/useJackpotsConfiguration';

export const Game = ({ code, setGameRef, hideButtons, gameLaunchType, category, categoryName, mostPlayedGame }) => {
    const { showJackpots, showGuaranteedHitTime, showGreenTubeJackpots, showSkyWindJackpots } = useJackpotsConfiguration();

    const { isLoggedIn } = useUserSelector(pick(['isLoggedIn']));
    const isRecentlyPlayed = category === CATEGORY_TYPE.RECENTLY;
    const isFavourite = category === CATEGORY_TYPE.FAVORITES;

    return (
        <div className={style.game} ref={setGameRef}>
            <CommonGame {...{
                setGameRef,
                code,
                hideButtons,
                gameLaunchType,
                className: style.gameInner,
                showTitle: false,
                showRecentlyPlayedIcon: isRecentlyPlayed,
                showFavoriteIcon: isLoggedIn,
                showFeatureIcons: true,
                showGameInfo: !isRecentlyPlayed && !isFavourite,
                disableGameLaunch: hideButtons,
                isExpandedCategoryPopup: true,
                categoryName,
                mostPlayedGame
            }} />
            <div className={style.jackpotWrapper}>
                <Jackpot
                    gameCode={code}
                    showGuaranteedHitTime={showGuaranteedHitTime}
                    isShowJackpot={showJackpots}
                    showGreenTube={showGreenTubeJackpots}
                    showSkyWind={showSkyWindJackpots}
                    isRegularJackpot={showJackpots}
                />
            </div>
        </div>
    );
};

export default compose(
    pure,
    withProps(
        ({ code }) => {
            const { name } = useAppSelector(path(['games', code]));

            return {
                name
            };
        }
    ),
    withState('resizeObserver', 'setResizeObserver',
        () => new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) {
                entry.target.querySelector('[loading]').style.backgroundImage = `url("${entry.target.querySelector('[loading]').dataset.src}")`;
            }
        })),
    withHandlers(({ setGameRef }) => ({
        setGameRef: ({ resizeObserver }) => (ref) => {
            if (setGameRef) {
                setGameRef(ref);
            }

            if (ref != null) {
                resizeObserver.observe(ref);
            } else {
                resizeObserver.disconnect();
            }
        }
    })),
    mapProps(omit([
        'resizeObserver',
        'setResizeObserver'
    ]))
)(Game);
